export const COOKIE = 'squire-analytics';

export const SET_ACCEPT_COOKIE = 'SET_ACCEPT_COOKIE';



// WEBPACK FOOTER //
// ./src/app/acceptCookies/constants.js